// Author liang gang qiang
// Date 2023-10-25 14:30:45

class SithMomMainProjectPlanScheduledRecord {
constructor({
        id = null,
        mainProjectPlanDetailId = '',
        ppdChineseDescription = '',
        scheduledResultId = '',
        finishVariance = '',
        durationVariance = '',
        reasonType = '',
        reason = '',
        delivery = '',
        deliveryDays = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mainProjectPlanDetailId = mainProjectPlanDetailId;
    this.ppdChineseDescription = ppdChineseDescription;
    this.scheduledResultId = scheduledResultId;
    this.finishVariance = finishVariance;
    this.durationVariance = durationVariance;
    this.reasonType = reasonType;
    this.reason = reason;
    this.delivery = delivery;
    this.deliveryDays = deliveryDays;
    this.remark = remark;
}
}

function newEntity() {
return new SithMomMainProjectPlanScheduledRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'network',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.network',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectName',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'machine1',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.machine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'wbsNumber',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.wbsNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'pm',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.pm',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'pmName',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.pmName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'om',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.om',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'omName',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.omName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'activityId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.activityId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'milestoneCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.milestoneCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'resource',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.resource',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reasonTypeName',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.reasonTypeName',
        sortable: true,
            translateFromField: 'reasonType',
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'reason',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.reason',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'delivery',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.delivery',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'deliveryDays',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.deliveryDays',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    mainProjectPlanDetailIdFilter : '',
    scheduledResultIdFilter : '',
    scheduledResultIdIsNullFilter : '',
    projectCodeFilter : '',
    projectNameFilter : '',
    machine1Filter : '',
    wbsNumberFilter : '',
    cidFilter : '',
    pmNameFilter : '',
    omNameFilter : '',
    prpIdFilter : '',
    prpIdInFilter : [],
    finishVarianceFilter : '',
    durationVarianceFilter : '',
    milestoneCodeFilter : '',
    resourceFilter : '',
    reasonTypeFilter : '',
    reasonFilter : '',
    deliveryFilter : '',
    deliveryDaysFilter : '',
    createdByFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectNameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.projectName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'machine1Filter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.machine1',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsNumberFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.wbsNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'cidFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.cid',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pmNameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.pmName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omNameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.omName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'milestoneCodeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.milestoneCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'resourceFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.resource',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reasonTypeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.reasonType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '项目' },
                { value: '2', text: '工程' },
                { value: '3', text: '采购' },
                { value: '4', text: '生产' },
                { value: '5', text: '负荷' },
                { value: '6', text: '客户' },
                { value: '7', text: '转子' },
                { value: '8', text: '轴承' },
                { value: '9', text: '其他' }
            ]
        }
        },
        {
        key: 'reasonFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.reason',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deliveryFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.delivery',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deliveryDaysFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.filter.deliveryDays',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'ppdChineseDescription',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.entity.ppdChineseDescription',
        sortable: true,
        disabled: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scheduledResultId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.entity.scheduledResultId',
        sortable: true,
        disabled: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'reasonType',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.entity.reasonType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '项目' },
                { value: '2', text: '工程' },
                { value: '3', text: '采购' },
                { value: '4', text: '生产' },
                { value: '5', text: '负荷' },
                { value: '6', text: '客户' },
                { value: '7', text: '转子' },
                { value: '8', text: '轴承' },
                { value: '9', text: '其他' }
            ]
        }
        },
        {
        key: 'reason',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.entity.reason',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'delivery',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.entity.delivery',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'deliveryDays',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.entity.deliveryDays',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlanScheduledRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMomMainProjectPlanScheduledRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
